var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default"},[_c('div',{staticClass:"banner"},[_c('p',[_vm._v(_vm._s(_vm.$t('obsolete_banner')))]),_c('a',{attrs:{"href":"//beautec.ca","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('beautec_link')))])]),_c('Navbar'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }